module.exports = {
    INSPIRED_BY_VIEWS: 'inspired_by_recent_views',
    MINIMUM_ITEMS: 5
};
